<template>
<v-card width="300px" class="rounded-card">
    <v-card-title class="teal mb-2 py-2">
        {{group.code}} - {{group.name}}
    </v-card-title>
    <v-layout>
      <v-flex xs9>
      <v-card-text class="py-1">
          <span>{{$t('Type')}}: </span>
          <span class="font-weight-medium">{{$t(group.groupType)}}</span>
      </v-card-text>
      <v-card-text class="py-1">
          <span>{{$t('Cows Count')}}: </span>
          <span class="font-weight-medium">{{group.cowCount}}</span>
      </v-card-text>
      </v-flex>
      <v-flex xs3>
      <v-btn icon @click.stop="edit()">
        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-icon color="primary" v-on="on">mdi-square-edit-outline</v-icon>
          </template>
          <span>{{this.$i18n.t('Edit group') + " " + group.code}}</span>
        </v-tooltip>
      </v-btn>
      </v-flex>
    </v-layout>
    <!-- <v-card-actions class="py-0">

    </v-card-actions> -->
    <AddEditGroupDialog v-bind:value.sync="showDialog" v-bind:groupId="groupId" v-on:close="close" />
</v-card>
</template>

<script>
import AddEditGroupDialog from "../components/AddEditGroup";

export default {
  name: "GroupPanel",
  props: ["groupId"],
  data()  {
    return {
      showDialog: false,
    }
  },
  computed: {
      group() {
        return this.$store.getters.getGroup(this.groupId);
      },
  },
  methods: {
    edit() {
      this.showDialog=true;
    },
    close() {
      this.showDialog=false;
    }
  },
  components: {
     "AddEditGroupDialog": AddEditGroupDialog,
  }

}
</script>

<style>
  .rounded-card {
    border-radius:8px;
  }
</style>
